// extracted by mini-css-extract-plugin
export default {"brass-tab-container":"BottomPanel_brass-tab-container__HTOEU","list-view":"BottomPanel_list-view__1MtLM"};